/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TCTriggerListResponse } from '../models/TCTriggerListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AutomationsTriggersService {
    /**
     * List trigger catalog
     * @param limit
     * @param pageToken
     * @returns TCTriggerListResponse Ok
     * @throws ApiError
     */
    public static listTriggers(
        limit?: number,
        pageToken?: string,
    ): CancelablePromise<TCTriggerListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/automations/triggers',
            query: {
                'limit': limit,
                'pageToken': pageToken,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
